export default __webpack_public_path__ + "images/0xc38464250f51123078bbd7ea574e185f6623d037.png";